<script lang="ts" setup>
import { computed } from 'vue'
import { SwitchSize } from './types'

interface Props {
  checked?: boolean
  size?: keyof typeof SwitchSize
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  checked: false,
  size: SwitchSize.sm,
  disabled: false,
})

const toggleClass = computed((): string[] => {
  const cls = [
    'relative',
    'inline-flex',
    'flex-shrink-0',
    'border-2',
    'border-transparent',
    'rounded-full',
    'transiton-colors',
    'ease-in-out',
    'duration-150',
    'focus:outline-none',
    'group-focus:ring-2',
    'group-focus:ring-blue-600',
    'group-focus:ring-offset-2',
  ]

  if (props.disabled)
    cls.push('bg-gray-50')

  else if (props.checked)
    cls.push('bg-gray-800')

  else
    cls.push('bg-gray-300')

  if (props.size === SwitchSize.sm)
    cls.push('h-4 w-6')

  else
    cls.push('w-12 h-8')

  return cls
})

const dotClass = computed(() => {
  const cls = []

  if (props.disabled)
    cls.push('bg-gray-200')
  else
    cls.push('bg-white')

  if (props.size === SwitchSize.sm) {
    cls.push('w-3 h-3')
    if (props.checked)
      cls.push('translate-x-2')
  }
  else {
    cls.push('w-7 h-7')
    if (props.checked)
      cls.push('translate-x-4')
  }

  if (!props.checked)
    cls.push('translate-x-0')

  return cls
})
</script>

<template>
  <div :class="toggleClass">
    <i
      aria-hidden="true"
      class="pointer-events-none inline-block rounded-full transition duration-150 ease-in-out"
      :class="dotClass"
    />
  </div>
</template>
